<template>
    <div class="btn-group" :class="{open: isOpen === true}">
        <a
            :class="buttonClass"
            v-on:click="toggle"
            v-click-outside="hide"
        >
            {{name}}
            <span class="caret"></span>
        </a>
        <ul class="dropdown-menu" :class="'pull-' + position" role="menu">
            <slot></slot>
        </ul>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';

    export default {
        props: {
            classes: {
                type: String,
                default: 'btn-info btn-sm',
            },
            name: {
                type: String,
            },
            position: {
                type: String,
                default: 'right'
            },
        },
        data() {
            return {
                isOpen: false,
                buttonClass: this.classes + ' btn dropdown-toggle',
            };
        },
        methods: {
            toggle () {
                this.isOpen = !this.isOpen;
            },

            hide () {
                this.isOpen = false;
            }
        },
        mounted () {
            this.popupItem = this.$el
        },
        directives: {
            ClickOutside,
        },
    }
</script>
